import {
  calculateCareerStatistics,
  projectTournamentHistory,
  projectAchievements,
  inferFavoriteEvents,
} from "../../../domain/player/playerCareer";
import { projectPickleballSportAchievements } from "../../../domain/player/playerAchievementFramework";
import { projectPickleballMatchIntelligence } from "../../../domain/matchHistory/buildMatchIntelligence";

/**
 * Pickleball statistics — same career primitives, sport-scoped card lists from callers.
 */
export function createPickleballStatisticsProvider() {
  return {
    calculateCareerStatistics,
    projectTournamentHistory,
    projectAchievements,
    inferFavoriteEvents,
    projectSportAchievements: projectPickleballSportAchievements,
    projectMatchIntelligence: projectPickleballMatchIntelligence,
  };
}
